import React, { useEffect, useState } from "react"
import { Loader } from "react-feather"
import AppointmentType from "./AppointmentType"
import { useFormStore } from "../../ArchitektAufAnfrage/formStore"

const BookingTypeField = ({ field, methods, className }) => {
  const [employee, setEmployee] = useState(null)

  const { data } = useFormStore((state) => ({
    data: state.data,
  }))

  const selectedEmployee = data?.[field.employee_key]

  useEffect(() => {
    if (selectedEmployee) {
      setEmployee(JSON.parse(selectedEmployee))
    }
  }, [selectedEmployee])

  if (!employee) {
    return (
      <div className="mx-auto w-fit">
        <Loader className="mx-auto h-8 w-8 motion-safe:animate-spin" />
        <span>Lade Daten..</span>
      </div>
    )
  }

  const { appointmentTypes } = employee

  return !!appointmentTypes.length > 0 ? (
    <div className="grid grid-cols-1 sm:grid-cols-1 gap-4">
      {appointmentTypes.map((appointmentType, i) => (
        <AppointmentType
          key={i}
          field={field}
          methods={methods}
          appointmentType={appointmentType}
        />
      ))}
    </div>
  ) : (
    <div className="text-center">
      Aktuell sind leider keine Termine verfügbar.
      <br />
      Versuchen Sie es zu einem anderen Zeitpunkt erneut, oder schreiben Sie
      eine E-Mail an{" "}
      <a
        className="underline underline-offset-2"
        href="mailto:anfrage@planmaschine.de"
      >
        anfrage@planmaschine.de
      </a>
    </div>
  )
}

export default BookingTypeField
